import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { JugadoresEquipoParaCambioDTO } from "@/interfaces/Inscripcion";
import { ActualizarPairingEquiposDTO } from "@/interfaces/Partidas";
import { getJugadoresEquipos } from "@/services/InscripcionesService";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCambiarPairingEquipo',
  props: {
    isVisible: { type: Boolean },
    idEquipo1: {},
    idEquipo2: {},
    nombreEquipo1: {},
    nombreEquipo2: {}
  },
  emits: ["actualizar", "cerrar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isVisible = ref(props.isVisible);
watch(
  () => props.isVisible,
  (val) => (isVisible.value = val)
);

const jugadorEquipo1Seleccionado = ref<number | null>(null);
const jugadorEquipo2Seleccionado = ref<number | null>(null);
const equipos = ref<JugadoresEquipoParaCambioDTO[]>([]);
const equipo1 = ref<JugadoresEquipoParaCambioDTO>();
const equipo2 = ref<JugadoresEquipoParaCambioDTO>();
const isloading = ref<boolean>(false);

const cargarJugadores = async () => {
  isloading.value = true;
  try {
    const response = await getJugadoresEquipos(
      props.idEquipo1,
      props.idEquipo2
    );
    equipos.value = response.data;
    equipo1.value = equipos.value.find((e) => e.idEquipo === props.idEquipo1);
    equipo2.value = equipos.value.find((e) => e.idEquipo === props.idEquipo2);
  } catch (error) {
    console.error("Error cargando jugadores", error);
  } finally {
    isloading.value = false;
  }
};

const resetSeleccion = () => {
  jugadorEquipo1Seleccionado.value = null;
  jugadorEquipo2Seleccionado.value = null;
};

// También si se monta ya abierto, como desde la tarjeta de la partida
watch(
  isVisible,
  (val) => {
    if (val) {
      cargarJugadores();
      resetSeleccion();
    }
  },
  { immediate: true }
);

const actualizar = () => {
  if (
    jugadorEquipo1Seleccionado.value &&
    jugadorEquipo2Seleccionado.value &&
    equipo1.value &&
    equipo2.value
  ) {
    const jugador1 = equipo1.value.componentesEquipoDTO.find(
      (j) => j.idUsuario === jugadorEquipo1Seleccionado.value
    );
    const jugador2 = equipo2.value.componentesEquipoDTO.find(
      (j) => j.idUsuario === jugadorEquipo2Seleccionado.value
    );

    if (jugador1 && jugador2) {
      emit("actualizar", {
        idJugador1: jugador1.idUsuario,
        nombreEquipo1: props.nombreEquipo1,
        ejercitoEquipo1: jugador1.ejercito,
        nick1: jugador1.nick,
        idJugador2: jugador2.idUsuario,
        nombreEquipo2: props.nombreEquipo2,
        ejercitoEquipo2: jugador2.ejercito,
        nick2: jugador2.nick,
      });
      cerrar();
    }
  }
};
const cerrar = () => emit("cerrar");

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isVisible).value = $event)),
    "max-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5" }, {
            default: _withCtx(() => [
              _createTextVNode("Cambiar Pairing")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: jugadorEquipo1Seleccionado.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((jugadorEquipo1Seleccionado).value = $event)),
                        items: equipo1.value?.componentesEquipoDTO || [],
                        "item-title": "nick",
                        "item-value": "idUsuario",
                        label: `${_ctx.nombreEquipo1}`,
                        disabled: (equipo1.value?.componentesEquipoDTO?.length || 0) === 0,
                        loading: isloading.value
                      }, null, 8, ["modelValue", "items", "label", "disabled", "loading"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: jugadorEquipo2Seleccionado.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((jugadorEquipo2Seleccionado).value = $event)),
                        items: equipo2.value?.componentesEquipoDTO || [],
                        "item-title": "nick",
                        "item-value": "idUsuario",
                        label: `${_ctx.nombreEquipo2}`,
                        disabled: (equipo2.value?.componentesEquipoDTO?.length || 0) === 0,
                        loading: isloading.value
                      }, null, 8, ["modelValue", "items", "label", "disabled", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "justify-end" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "grey",
                variant: "tonal",
                onClick: cerrar
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cerrar")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "tonal",
                onClick: actualizar,
                disabled: !jugadorEquipo1Seleccionado.value || !jugadorEquipo2Seleccionado.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Actualizar ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})